import {
  formApiClient,
  formDefinitionApiClient,
} from 'src/api/ProactApiClientInstances';
import {registerFormsOffline} from 'src/app/forms/registerFormsOffline';

// Composition root for forms offline replay: binds the API client to the
// domain registration in src/app, which may not import the client itself.
registerFormsOffline({
  getOfflineBundle: () => formDefinitionApiClient.getOfflineBundle(),
  createForm: request => formApiClient.create(request),
  getForm: id => formApiClient.get(id),
  getStateMachine: () => formApiClient.getStateMachine(),
  transitionForm: (id, request) => formApiClient.transition(id, request),
});
